// Centralised dashboard IDs file.
// Menu keys here must match src/data/sidebar_config.js.

// Active Dashboard IDs
export const social_impact_intelligence_dashboard_id = 'd7103162-5006-48a9-bdc3-55280e12d2df';

// Standby Dashboard IDs (Placeholders)
export const skills_development_youth_employment_dashboard_id = 'standby-id';
export const sdye_compliance_dashboard_id = '27f6b76e-3bb6-4db8-bbaa-46a7af1f64c4';
export const sdye_programmes_delivery_dashboard_id = '642c8c5d-3634-4dea-bf9d-ac13b1c831fc';
export const sdye_social_impact_dashboard_id = '754a5eb2-0f91-49ac-9b1b-cba3e214fa8e';

export const socio_economic_development_dashboard_id = 'standby-id';
export const sed_compliance_dashboard_id = 'f2d2be91-006a-43ae-ae10-15454d6cdcbb';
export const sed_programmes_delivery_dashboard_id = 'fd7f3484-d736-45a1-9a54-69ab47429677';
export const sed_social_impact_dashboard_id = '96aa338d-db35-4cea-bf30-c1dd0c47fec8';

export const impact_exchange_rate_engine_dashboard_id = 'standby-id';
export const fund_performance_capital_recycling_dashboard_id = 'standby-id';
export const real_time_operations_asset_control_dashboard_id = 'standby-id';

// Default main dashboard
export const main_dashboard_id = social_impact_intelligence_dashboard_id;

export const default_dashboard_menu_key = 'social_impact_intelligence';

// Dashboard mapping per sidebar nav key.
export const dashboard_ids_by_menu_key = {
  default: social_impact_intelligence_dashboard_id,
  [default_dashboard_menu_key]: social_impact_intelligence_dashboard_id,

  // SDYE
  skills_development_youth_employment: skills_development_youth_employment_dashboard_id,
  sdye_compliance: sdye_compliance_dashboard_id,
  sdye_programmes_delivery: sdye_programmes_delivery_dashboard_id,
  sdye_social_impact: sdye_social_impact_dashboard_id,
  
  // SED
  socio_economic_development: socio_economic_development_dashboard_id,
  sed_compliance: sed_compliance_dashboard_id,
  sed_programmes_delivery: sed_programmes_delivery_dashboard_id,
  sed_social_impact: sed_social_impact_dashboard_id,
  
  // Others
  impact_exchange_rate_engine: impact_exchange_rate_engine_dashboard_id,
  fund_performance_capital_recycling: fund_performance_capital_recycling_dashboard_id,
  real_time_operations_asset_control: real_time_operations_asset_control_dashboard_id
};

export const role_dashboards = {
  fund_manager: dashboard_ids_by_menu_key,
  donor_portal: dashboard_ids_by_menu_key,
  governance: dashboard_ids_by_menu_key,
  entrepreneur: dashboard_ids_by_menu_key
};
